export const Bank = {
    path: '/banks',
    name: 'banks',
    component: () => import('@/views/Bank/BankPage.vue'),
    children: [
        {
            path: '/banks/add',
            name: 'banks.add',
            component: () => import('@/views/Bank/Form/BankForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/banks/edit/:id',
            name: 'banks.edit',
            component: () => import('@/views/Bank/Form/BankForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/banks/delete/:id',
            name: 'banks.delete',
            component: () => import('@/views/Bank/Form/BankForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/banks/view/:id',
            name: 'banks.view',
            component: () => import('@/views/Bank/Form/BankForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/banks/xlsx/fields/mapper/:id',
            name: 'banks.xlsxmapper',
            component: () => import('@/views/Bank/Form/XLSXFieldMapper.vue'),
        },
        {
            path: '/banks/xlsx/upload/model/:id',
            name: 'banks.uploadmodel',
            component: () => import('@/views/Bank/Form/UploadModelFile.vue'),
        },
    ]
}